const balanceGroup = {
  SAF: "saf",
};

const NABISY = "NABISY";
const GENERATED = "GENERATED";

module.exports = {balanceGroup, NABISY, GENERATED};
